import { SvgIcon, Button, Flex, Collapsible, Box } from '@volue/wave-react';
import type { PropsWithChildren } from 'react';
import React from 'react';

import { SaveCalculationSetExecutionReport } from '@/features/build-calculation-context/components/Home/components/SelectedFeaturePanel/SaveCalculationSetExecutionReport';
import { InlineNotification } from '@/features/execute-calculation-set/components/Calculation/InlineNotification';
import { ShareExecutionButton } from '@/features/execute-calculation-set/components/Calculation/components/CalculationHeader';
import { useActions } from '@/overmind';

export function InlineErrorWithRetryButton(
  props: PropsWithChildren<{
    handleRetryExecutingCalculationSet: () => void;
    text: string | JSX.Element;
  }>
) {
  const { shareCalculationSetExecution } = useActions().calculation;
  return (
    <div className="h100 w100 dF jcC aiC beta fdC pHxl mHxl">
      <InlineNotification
        type="ERROR"
        className="mAl"
        content={props.text}
        actionButtons={[
          <Flex
            flow="column"
            css={{
              justifyContent: 'space-between',
              textAlign: 'center',
              fontSize: 'small'
            }}
          >
            <Button
              className="w100"
              data-testid="run-calculation-set-btn"
              leftIcon={<SvgIcon iconName="play" />}
              onClick={props.handleRetryExecutingCalculationSet}
            >
              {'Try again'}
            </Button>
            {props.children}
            <ShareExecutionButton
              buttonClassName="w100"
              shareCalculationSetExecution={shareCalculationSetExecution}
            />
            <SaveCalculationSetExecutionReport
              text="Save error report to JSON"
              variant="outline"
            />
          </Flex>
        ]}
      />
    </div>
  );
}
